import { render, staticRenderFns } from "./Recados.vue?vue&type=template&id=420ff5a8&"
import script from "./Recados.vue?vue&type=script&lang=js&"
export * from "./Recados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports